// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"ab8985cea9e72c443802","404":"876c6164680f1b5a182f","406":"5c51eb27bfee7b7d54d3"}[chunkId] + ".css";
};